import React, { Component, useState, useEffect} from 'react'
import { connect } from 'react-redux'
import { Table, FormControl, Image, Button, OverlayTrigger, Modal, Tooltip, Collapse } from 'react-bootstrap'
import 'bootstrap-daterangepicker/daterangepicker.css'
import moment from 'moment'
import 'moment/locale/de'

import '../../index.css'
import { FetchApproveCorrection, FetchDeleteTransactionDraft, FetchReadOutgoingTransactions, FetchArticleTypeImages } from '../../fetcher'
import { getSizeEntries, getSizeNumbers, getCorrectionNumbers, getTotal } from '../presentational-components/TableComponent'
import AlertMessage from '../presentational-components/AlertMessage'
import { ModalComponent } from '../presentational-components/ModalComponent'
import DeliveryOrderContainer from './DeliveryOrderContainer'
import DescriptionTooltip from '../presentational-components/DescriptionTooltip'
import { RenderImage } from '../presentational-components/ImageViewer'
import EnumValueTranslations from '../presentational-components/EnumValueTranslations';
import { ExportCSV } from '../presentational-components/ExportCSV'
import { useExpandRows, useSortTransactions } from '../presentational-components/tablehooks'
import { DateSelect, StateSelect, useDateFilter, useFilterTransactions, useSearchFilter, useSelectFilter } from '../presentational-components/filterutils'
import LoadingSpinner from '../presentational-components/LoadingSpinner';

moment.locale('de')

const getColourClassStatus = (status) => {
    //if (status == "InTransit") return "inTransit"
    if (status == "Confirmed") return "approved"
    else if (status == "Inaccurate") return "correction"
    else return "inTransit"
}
    
const correctionColor = (inaccurateState) => {
    return (inaccurateState == true ? "correction-corrected" : "correction-approved")
}

const OutgoingTransactions = () => {
    const [isFaexStorage, setIsFaexStorage] = useState(false)

    const [showAlertMessage, setShowAlert] = useState(false)
    const openAlert = () => {
        setShowAlert(true)
    }
    const closeAlert = () => {
        setShowAlert(false)
    }

    const [outgoingTransactions, setOutgoingTransactions] = useState([])
    const [articleDataReady, setArticleDataToReady] = useState(false)

    const [analysis, setAnalysis] = useState(false)

    const [taskName, setTaskName] = useState("OutgoingTransactions unbekannte Task")

    const controller = new AbortController()
    const signal = controller.signal

    const handleSetAnalysis = () => {
        setAnalysis(!analysis)
        controller.abort()
    }

    const addingImages = (articleTypeImages) => {
        let copiedOutgoingTransactions = [...outgoingTransactions]
        articleTypeImages.forEach(image => copiedOutgoingTransactions.flatMap(x => x.Articles).filter(x => x.ArticleTypeSysId == image.ArticleTypeSysId).forEach(xfiltered => xfiltered.Image = 'data:image/png;base64,' + image.Data))
        setOutgoingTransactions(copiedOutgoingTransactions)
    }

    const [filteredOutgoingTransactions, setFilteredOutgoingTransactions] = useState([])
    const [sortedOutgoingTransactions, setSortedOutgoingTransactions] = useState([])
    const [filterArticles, setFilterArticles] = useState(false)
    const toggleFilterArticles = () => {
        setFilterArticles(!filterArticles)
    }

    const { sortTransactions } = useSortTransactions(outgoingTransactions, setSortedOutgoingTransactions)
    const { expandRow, getIsExpandedRow } = useExpandRows()
    const { filterTransactionsBySearchInput, filterTransactionsAndArticlesBySearchInput, filterTransactionsByDateInput, filterTransactionsBySelectInput } = useFilterTransactions()
    const { dateSelect, handleDatePickerCallback, handleClearFilter } = useDateFilter()
    const [statusSelect, handleStatusSelectChange] = useSelectFilter()
    const { searchInput, handleSearchInput } = useSearchFilter()

    const handleSetOutgoingTransactions = (transactions) => {
        setOutgoingTransactions(transactions/*.filter(x => item.State != "Confirmed" && item.Type != "Sales")*/)
    }

    useEffect(() => {
        if (JSON.parse(sessionStorage.getItem("loginInformation")).StorageType === "FAEX") {
            setIsFaexStorage(true)
        }
    }, []);

    useEffect(() => {
        if (analysis) {
            setTaskName("Die ausgehende Transaktionen werden geladen")
            FetchReadOutgoingTransactions(handleSetOutgoingTransactions, openAlert, setArticleDataToReady, signal, "OutgoingTransactions")
        }
        return () => {
            controller.abort()
        }
    }, [analysis]);

    useEffect(() => {
        if (articleDataReady) {
            setTaskName("Die Bilder werden geladen")
            FetchArticleTypeImages(outgoingTransactions.flatMap(x => x.Articles).map(x => x.ArticleTypeSysId.toString()), addingImages, openAlert, "OutgoingTransactions")
        }
    }, [articleDataReady])

    useEffect(() => {
        setFilteredOutgoingTransactions([...outgoingTransactions])
        setSortedOutgoingTransactions([...outgoingTransactions])
    }, [outgoingTransactions])

    const takeSortedOutgoingTransactions = () => {
        //Maybe this shouldn't be done in general, as there should be another option to deep clone an object!
        let deepCopy = JSON.parse(JSON.stringify(sortedOutgoingTransactions))
        return deepCopy
    }

    useEffect(() => {
        let filteredTransactions = filterArticles ? filterTransactionsAndArticlesBySearchInput(takeSortedOutgoingTransactions(), searchInput) : filterTransactionsBySearchInput(sortedOutgoingTransactions, searchInput)
        filteredTransactions = filterTransactionsByDateInput(filteredTransactions, dateSelect)
        filteredTransactions = filterTransactionsBySelectInput(filteredTransactions, statusSelect)

        setFilteredOutgoingTransactions(filteredTransactions)
    }, [searchInput, dateSelect, statusSelect, sortedOutgoingTransactions, filterArticles])

    const reload = () => {
        if (analysis) {
            setTaskName("Die ausgehende Transaktionen werden geladen")
            FetchReadOutgoingTransactions(handleSetOutgoingTransactions, openAlert, setArticleDataToReady, signal, "OutgoingTransactions")
        } else {
            controller.abort()
        }
    }

    const [showDeliveryMask, setShowDeliveryMask] = useState(false)
    const toggleShowDeliveryMask = () => {
        setShowDeliveryMask(!showDeliveryMask)
    }
    const handleShowDeliveryMask = () => {
        setShowDeliveryMask(true)
    }
    const handleCloseDeliveryMask = () => {
        setShowDeliveryMask(false)
    }

    const [showBackDeliveryMask, setShowBackDeliveryMask] = useState(false)
    const toggleShowBackDeliveryMask = () => {
        setShowBackDeliveryMask(!showBackDeliveryMask)
    }
    const handleShowBackDeliveryMask = () => {
        setShowBackDeliveryMask(true)
    }
    const handleCloseBackDeliveryMask = () => {
        setShowBackDeliveryMask(false)
    }

    const [draftToUpdate, setDraftToUpdate] = useState()

    const [showDeliveryDraftMask, setShowDeliveryDraftMask] = useState(false)
    const handleShowDeliveryDraftMask = () => {
        setShowDeliveryDraftMask(true)
    }
    const handleCloseDeliveryDraftMask = () => {
        setShowDeliveryDraftMask(false)
    }

    const removeTransactionDraft = (e, sysId) => {
        e.preventDefault()
        setTaskName("Die ausgewählte Entwürfe werden gelöscht")
        FetchDeleteTransactionDraft(sysId, openAlert, reload, "OutgoingTransactions")
    }

    const updateTransactionDraft = (e, transactionDraft) => {
        e.preventDefault()
        console.log("updateTransactionDraft")
        console.log(transactionDraft)
        setDraftToUpdate(transactionDraft)
        setShowDeliveryDraftMask(true)
    }

    let allItemRows = []

    const [expandedRows, setExpandedRows] = useState([])

    const getCsvFileName = (transactionSysId, date, deliveryTo) => {
        return (date.replace(".", "-") + "_Lieferschein_An_" + deliveryTo )
    }

    const getCsvData = (articles, sizeCategories) => {
        let csvArrayData = []

        sizeCategories.forEach(x => {

            let csvData = []

            articles.sort((a, b) => a.DesignerName.localeCompare(b.DesignerName) || a.Name.localeCompare(b.Name))
                .filter(y => y.SizeCat === x).forEach(article => {
                    let object =
                    {
                        "Designername": article.DesignerName,
                        "Artikelnr": article.ArticleIdFaex,
                        "Artikelnr. Designer": article.ArticleNumberDesigner,
                        "Artikelname": article.Name,
                        "Größenkategorie" : x,
                        "Farbe": article.Colour,
                        "Vk-Preis": article.SalePrice,
                    }

                    article.Sizes.forEach(size =>
                    {
                        let key = size.SizeValue.toString() + " "
                        let value = size.Amount
                        let sizePair = { [key] : value }

                        object = {...object, ...sizePair}
                    })

                    let numbers = article.Sizes.map(entry => parseInt(entry.Amount))
                    let total = 0
                    numbers.map(number => total = parseInt(total) + parseInt(number))
                    let totalPair = {"Total": total}
                    object = { ...object, ...totalPair }

                    csvData.push(object)
                }
            )
            csvArrayData.push(csvData)
        })
        return (csvArrayData)
    }

    const getTotalTotal = (articleTypes) => {
        let numbersTotal = 0
        articleTypes.forEach(x => {
            let numbers = x.Sizes.map(entry => parseInt(entry.Amount))
            let total = 0
            numbers.map(number => total = parseInt(total) + parseInt(number))

            numbersTotal += total
        })

        return numbersTotal
    }

    const [showCorrectionModal, setShowCorrectionModel] = useState(false)
    const [confirmTransactionSysId, setTransactionSysId] = useState("")

    const handleCloseCorrectionModal = () => setShowCorrectionModel(false)

    function handleShowCorrectionModal(transactionSysId) {
        setShowCorrectionModel(true)
        setTransactionSysId(transactionSysId)
    }

    const handleApproveCorrection = () => {
        if (confirmTransactionSysId != "") {
            const stateChangeModel = {
                AbstractTransactionSysId: confirmTransactionSysId,
                OldState: "InProcess"
            };

            setTaskName("Die Transaktion wird geupdatet")
            FetchApproveCorrection(stateChangeModel, handleCloseCorrectionModal, reload)
        }
    }

    const handleRowClick = (rowId) => {
        const currentExpandedRows = expandedRows;
        const isRowCurrentlyExpanded = currentExpandedRows.includes(rowId);

        const newExpandedRows = isRowCurrentlyExpanded ?
            currentExpandedRows.filter(id => id !== rowId) :
            currentExpandedRows.concat(rowId);

        setExpandedRows(newExpandedRows)
    }

    const [filterable, setFilterable] = useState(false)
    const setFilterbar = () => {
        setFilterable(!filterable)
    }

    return (
        <div>
            
            <div className="tablet-center">
                <h1>Postausgang</h1>
                <div className="flex-linebreak"></div>
                <Button variant="secondary" className="new-transaction-btn" onClick={handleShowDeliveryMask}>Neuer Lieferschein</Button>
                &nbsp;
                {isFaexStorage ? <Button variant="secondary" className="new-transaction-btn" onClick={handleShowBackDeliveryMask}>Neuer Rücklieferschein</Button> : null}
                &nbsp;
                <Button variant="secondary" className="booking-btn" onClick={() => handleSetAnalysis()}>Auswertung</Button>
            </div>
            
            <div className="flex-linebreak"></div>

            {analysis &&
                <div className="inline">
                    <FormControl className="globalSearch searchBar" as="input" defaultValue={searchInput} placeholder="Suche..." onChange={handleSearchInput}></FormControl>
                    <Button variant="light" className="filter-button form-control" onClick={toggleFilterArticles}>{filterArticles ? "Lieferscheine filtern" : "Artikel filtern"}</Button>
                </div>
            }
            {/*<ExportCSV csvData={outgoingTransactions} fileName="Postausgang" />*/}

            {analysis && <div className="tablet-transactions">
                <Table className="table-sm table-striped-immediate ">
                    <thead className="sticky-table-header">
                        <th></th>
                        <th className="mainColumn">Lieferung an
                            <a href="" className="sort-link" onClick={(e) => sortTransactions(e, 'SourceOrTargetName')}>&#8593; &#8595;</a>
                        </th>
                        <th className="mainColumn">Erstellungsdatum
                            <a href="" className="sort-link" onClick={(e) => sortTransactions(e, 'CreationDate')}>&#8593; &#8595;</a>
                        </th>
                        <th className="mainColumn">Status
                            <a href="" className="sort-link" onClick={(e) => sortTransactions(e, 'State')}>&#8593; &#8595;</a>
                        </th>
                        <th className="mainColumn">Bemerkung
                            <a href="" className="sort-link" onClick={(e) => sortTransactions(e, 'Remark')}>&#8593; &#8595;</a>
                        </th>
                        <th className="filterIndicator" onClick={setFilterbar}>&#8711; Filter</th>
                        <th></th>
                    </thead>
                    {filterable ? <thead>
                        <th></th><th></th>
                        <th>{DateSelect(handleDatePickerCallback, handleClearFilter, dateSelect)}</th>
                        <th>{StateSelect([...new Set(outgoingTransactions.map(x => EnumValueTranslations(x.State)))], handleStatusSelectChange, statusSelect)}</th>
                        <th></th>
                        <th></th>
                        <th></th>
                    </thead> : null}
                    <tbody>
                        {filteredOutgoingTransactions.map(transaction =>
                            <>
                                <tr className="salesboutique-mainrow" onClick={(e) => expandRow(e, transaction.TransactionSysId)} aria-expanded={getIsExpandedRow(transaction.TransactionSysId)} aria-controls={transaction.TransactionSysId}>
                                    {getIsExpandedRow(transaction.TransactionSysId) ? <td className="expandIndicator">&#8722;</td> : <td className="expandIndicator">&#43;</td>}
                                    <td>{transaction.SourceOrTargetName}</td>
                                    <td>{transaction.CreationDate}</td>
                                    <td className={getColourClassStatus(transaction.State)}>{EnumValueTranslations(transaction.State)}</td>
                                    <OverlayTrigger trigger={["hover", "click"]} placement="top" overlay={DescriptionTooltip(transaction.Remark)}>
                                        <td className="remark-td">{transaction.Remark}</td>
                                    </OverlayTrigger>
                                    <td></td>
                                    {transaction.IsDraft &&
                                        <td>
                                            <OverlayTrigger placement="bottom" overlay={<Tooltip> Lieferschein bearbeiten </Tooltip>}>
                                                <Button className="button-mar" size="sm" variant="secondary" onClick={(e) => updateTransactionDraft(e, transaction)}>&#9998;</Button>
                                            </OverlayTrigger>
                                            <OverlayTrigger className="remove-order-td" placement="bottom" overlay={<Tooltip> Lieferschein löschen </Tooltip>}>
                                                <a className="remove-order" href="" onClick={(e) => removeTransactionDraft(e, transaction.TransactionSysId)} variant="secondary">&#10060;</a>
                                            </OverlayTrigger>
                                        </td>
                                    }
                                </tr>

                                
                                    <Collapse in={getIsExpandedRow(transaction.TransactionSysId)} timeout={30}>
                                        <td colSpan="6" className="td-nomargin">
                                        <div id={transaction.TransactionSysId} className="salesBoutique-child-div">
                                            {[...new Set(transaction.Articles.map(article => article.SizeCat))].map(sizeCat =>
                                                <>
                                                <thead className="sticky-table-header">
                                                    <tr>
                                                        <th className="imageColumn"></th>
                                                        <th>Designername</th>
                                                        <th>Artikelnr.</th>
                                                        <th>{sizeCat}</th>
                                                        <th>Farbe</th>
                                                        <th>Vk-Preis</th>
                                                        {getSizeEntries(transaction.Articles.find(x => x.SizeCat === sizeCat).Sizes)}
                                                        <th className="sizeColumn">Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {transaction.Articles.sort((a, b) => a.Name.localeCompare(b.Name))
                                                    .filter(x => x.SizeCat === sizeCat).map(article =>
                                                        <>
                                                            <tr>
                                                                <td className="imageColumn">{RenderImage(article.Image)}</td>
                                                                <td>{article.DesignerName}</td>
                                                                <td>{article.ArticleIdFaex}</td>
                                                                <td>{article.Name}</td>
                                                                <td>{article.Colour}</td>
                                                                <td className="numberColumn">{parseFloat(article.SalePrice).toFixed(2).replace('.', ',') + "€"}</td>
                                                                {getSizeNumbers(article.Sizes)}
                                                                {getTotal(article.Sizes)}
                                                            </tr>
                                                            {article.CorrectedArticles == true ?
                                                                <tr className={correctionColor(transaction.State == "Inaccurate")}>
                                                                    <td></td>
                                                                    <td>Korrektur:</td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    {getCorrectionNumbers(article.Sizes)}
                                                                </tr>
                                                                : null}
                                                        </>
                                                        )}

                                                        <tr className="stockReport-row">
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td>Summe: </td>
                                                            <td>{getTotalTotal(transaction.Articles)}</td>
                                                        </tr>

                                                    </tbody>
                                                </>
                                            )}
                                        </div>

                                        {transaction.State == "Inaccurate" ?
                                            <tr>
                                                <td></td>
                                                <td><Button variant="secondary" size="sm" onClick={() => handleShowCorrectionModal(transaction.TransactionSysId)}>Korrektur bestätigen &#10003;</Button></td>
                                            </tr>
                                            : null}

                                        <tr>
                                            <td></td>
                                            <td><ExportCSV className="searchBar" disabled={false} csvData={getCsvData(transaction.Articles, [...new Set(transaction.Articles.map(article => article.SizeCat))])} fileName={getCsvFileName(transaction.TransactionSysId, transaction.CreationDate, transaction.SourceOrTargetName)} isTransaction={true} /></td>
                                        </tr>

                                    </td>
                                </Collapse>
                            </>
                        )}
                    </tbody>
                </Table>
            </div> }

            <ModalComponent handleShow={showCorrectionModal} handleClose={handleCloseCorrectionModal} handleSubmit={handleApproveCorrection}
                reload={reload} modalTitle="Korrektur akzeptieren" modalBody="Möchten Sie die Korrektur für diesen Lieferschein wirklich akzeptieren?" />

            <ModalComponent handleShow={showDeliveryMask} handleClose={handleCloseDeliveryMask}
                reload={reload} modalTitle="Neuer Lieferschein" modalBody={<DeliveryOrderContainer handleCloseMask={handleCloseDeliveryMask} reloadParent={reload}/>} tabletView={true} />

            <ModalComponent handleShow={showBackDeliveryMask} handleClose={handleCloseBackDeliveryMask}
                reload={reload} modalTitle="Neuer Rücklieferschein" modalBody={<DeliveryOrderContainer handleCloseMask={handleCloseBackDeliveryMask} reloadParent={reload} backDelivery={true} />} tabletView={true} />

            <ModalComponent handleShow={showDeliveryDraftMask} handleClose={handleCloseDeliveryDraftMask}
                reload={reload} modalTitle="Lieferschein-Entwurf bearbeiten" modalBody={<DeliveryOrderContainer handleCloseMask={handleCloseDeliveryDraftMask} reloadParent={reload} draft={draftToUpdate}/>} tabletView={true} />

            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
            <LoadingSpinner task={taskName} area={"OutgoingTransactions"}/>

        </div>
    );
}

const mapStateToProps = state => ({
})

export default connect(mapStateToProps)(OutgoingTransactions)
